import type { EvalModel } from '../types/evalTypes';

/** One cell of the cases-by-arms matrix. */
export const cellKey = (caseId: string, armId: string): string => `${caseId}~${armId}`;

export const modelLabel = (models: EvalModel[], modelId: string): string =>
  models.find((model) => model.id === modelId)?.label ?? modelId;

/** "1 case", "2 cases". */
export const plural = (count: number, word: string): string => `${count} ${word}${count === 1 ? '' : 's'}`;

export const formatPercent =(rate: number | null): string => (rate === null ? '–' : `${Math.round(rate * 100)}%`);

export const formatPassRate = (passed: number, trials: number): string =>
  trials === 0 ? '–' : `${formatPercent(passed / trials)} (${passed}/${trials})`;

/** One decimal under 10 seconds, where model calls fall and a tenth matters. */
export const formatDuration = (ms: number): string => {
  if (ms < 9950) return `${(ms / 1000).toFixed(1)}s`;
  const seconds = Math.round(ms / 1000);
  return seconds < 60 ? `${seconds}s` : `${Math.floor(seconds / 60)}m ${seconds % 60}s`;
};

export const formatDateTime = (ms: number): string =>
  new Date(ms).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });

/** The production setup: the registry model with no effort and no draft prompt, as the new-run form makes it. */
export const isProductionArm = (arm: { model: string; effort?: string; hasPromptOverride: boolean }, productionModel: string | undefined): boolean =>
  arm.model === productionModel && !arm.effort && !arm.hasPromptOverride;

/** Who saved a judge prompt or case version, in words. */
export function versionAuthor(version: { createdBy: string; tokenName?: string }, currentUid: string | undefined): string {
  if (version.createdBy === 'seed') return 'from the code';
  if (version.tokenName !== undefined) return `Claude, token "${version.tokenName}"`;
  return version.createdBy === currentUid ? 'you' : version.createdBy;
}
